<template>
  <div :class="classnames">
    <div v-if="showPlaceholder" :class="`${ns}__placeholder`" />
    <h1 v-else :class="`${ns}__text`">{{ text }}</h1>
  </div>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'page-headline'

  export default {
    name: 'PageHeadline',
    mixins: [ bem ],
    props: {
      text: {
        default: '',
        type: String
      }
    },
    data () {
      return {}
    },
    computed: {
      showPlaceholder: function () {
        let textIsEmpty = false

        textIsEmpty = (this.text.length === 0 || this.text === '') && true

        return textIsEmpty
      }
    },
    created: function () {
      this.setNamespace(namespace)
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/PageHeadline.vue